function animatedsearch() {
  const input = document.getElementById("SearchForm_SearchForm_Search");
  const searchBtn = document.getElementById("SearchForm_SearchForm_action_results");
  const expand = () => {
    searchBtn.classList.toggle("close");
    input.classList.toggle("square");
  };
  searchBtn.addEventListener("click", expand);
}

export default {
    init: function () {
        animatedsearch();
    }
};
